import { render, staticRenderFns } from "./GoodsReturnDetails.vue?vue&type=template&id=4a9d98dc&scoped=true"
import script from "./GoodsReturnDetails.vue?vue&type=script&lang=js"
export * from "./GoodsReturnDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodsReturnDetails.vue?vue&type=style&index=0&id=4a9d98dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d98dc",
  null
  
)

export default component.exports